import React from 'react'
import { Link } from 'gatsby'
import * as ROUTES from '../../../constants/routes'

import 'bootstrap/dist/css/bootstrap.min.css'
import postStyles from './post.module.css'

const Post = ({ post, next, previous, location }) => {
    const postLocation = location.href

    const getDate = datetocalc => {
        const today = new Date()
        let todayDate =
            today.getFullYear() +
            `${today.getMonth() + 1}` +
            `0${today.getDate()}`

        const createdAt = datetocalc.slice(0, 10).replace(/-/g, '')

        if(todayDate.length === 9) {
            todayDate = todayDate.replaceAt(6, '');
        }

        const fromToday = parseInt(todayDate) - parseInt(createdAt)

        return {
            fromToday
        }
    }

    String.prototype.replaceAt = function(index, replacement) {
        if (index >= this.length) {
            return this.valueOf();
        }
    
        return this.substring(0, index) + replacement + this.substring(index + 1);
    }

    const imageSrc = post.image

    return (
        <>
            <div className={postStyles.imageContainer}>
                <img
                    src={
                        imageSrc === null
                            ? 'https://images.pexels.com/photos/5123471/pexels-photo-5123471.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260'
                            : imageSrc.url
                    }
                    alt="Girl in a jacket"
                    className={postStyles.image}
                ></img>
            </div>

            <div className={postStyles.container}>
                <h1 className={postStyles.title}>{post.title}</h1>

                <div className={postStyles.details}>
                    <Link to={ROUTES.ABOUT} className={postStyles.author}>
                        Gaji Femi
                    </Link>

                    <p className={postStyles.publishedAt}>
                        <span>Published:</span>

                        {getDate(post.createdAt).fromToday === 0
                            ? ' Today'
                            : ` ${getDate(post.createdAt).fromToday} days ago`}
                    </p>
                </div>

                <div className={postStyles.share}>
                    <a
                        href={`https://www.facebook.com/sharer/sharer.php?u=${postLocation}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <span className="fa fa-facebook"></span>

                        <span>Share</span>
                    </a>

                    <a
                        class="twitter-share-button"
                        href={`https://twitter.com/intent/tweet?text=${post.title} ${postLocation}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <span className="fa fa-twitter"></span>

                        <span>Tweet</span>
                    </a>
                </div>

                <div
                    dangerouslySetInnerHTML={{ __html: post.body.html }}
                    className={postStyles.body}
                />

                <div className={postStyles.category}>
                    <p>Categories:</p>

                    {post.category.map(category => (
                        <Link to={category} target="_blank">
                            {category}
                        </Link>
                    ))}
                </div>

                <ul className={postStyles.navBtn}>
                    <li>
                        {previous && (
                            <Link to={`/${previous.slug}`} rel="prev">
                                ← {previous.title}
                            </Link>
                        )}
                    </li>
                    <li>
                        {next && (
                            <Link to={`/${next.slug}`} rel="next">
                                {next.title} →
                            </Link>
                        )}
                    </li>
                </ul>

                {/* <Messages /> */}
            </div>
        </>
    )
}

export default Post
